let _animationInitBound = false;

export function animationInit() {
	if (_animationInitBound) return; // prevent double-binding
	_animationInitBound = true;

	const fadeInElements = document.querySelectorAll('.fade-in');
	const countElements = document.querySelectorAll('.count-up');

	// =========================
	// Fade-in + Stagger + Count
	// =========================
	const animateOnScroll = () => {
		const scrollY = window.scrollY;
		const windowHeight = window.innerHeight;

		// Fade-in logic
		fadeInElements.forEach((el) => {
			const elementTop = el.getBoundingClientRect().top + scrollY;
			if (
				scrollY + windowHeight > elementTop + 100 &&
				!el.classList.contains('fade-in--active')
			) {
				el.classList.add('fade-in--active');

				// Trigger staggered children after short delay
				const staggerChildren = el.querySelectorAll('.stagger-child');
				staggerChildren.forEach((child, index) => {
					setTimeout(() => {
						child.classList.add('staggered--active');
					}, index * 150);
				});
			}
		});

		// Count-up logic
		countElements.forEach((el) => {
			const alreadyAnimated = el.getAttribute('data-animated');
			if (alreadyAnimated) return;

			const elementTop = el.getBoundingClientRect().top + scrollY;
			if (scrollY + windowHeight > elementTop + 50) {
				countUp(el);
				el.setAttribute('data-animated', 'true');
			}
		});
	};

	const countUp = (el) => {
		const target = parseFloat(el.getAttribute('data-target')) || 0;
		const duration = 2000;
		const frameRate = 30;
		const increment = target / (duration / frameRate);
		let current = 0;

		const countEl = el.querySelector('.count');
		if (!countEl) return;

		const prefix = el.getAttribute('data-prefix') || '';
		const suffix = el.getAttribute('data-suffix') || '';
		const decimalPlaces =
			(el.getAttribute('data-target') || '').split('.')[1]?.length || 0;

		const timer = setInterval(() => {
			current += increment;
			if (current >= target) {
				current = target;
				clearInterval(timer);
			}
			countEl.textContent = current.toFixed(decimalPlaces);
			const prefixEl = el.querySelector('.prefix');
			const suffixEl = el.querySelector('.suffix');
			if (prefixEl) prefixEl.textContent = prefix;
			if (suffixEl) suffixEl.textContent = suffix;
		}, frameRate);
	};

	// =========================
	// Subtle Parallax (Callout)
	// =========================
	const initCalloutParallax = () => {
		const sections = Array.from(
			document.querySelectorAll('.homepage-callout')
		);
		if (!sections.length) return;

		// Respect reduced motion preferences
		const reduceMotion = window.matchMedia(
			'(prefers-reduced-motion: reduce)'
		).matches;
		if (reduceMotion) return;

		const speed = 0.1;
		const baseOffset = 80;
		let ticking = false;

		const update = () => {
			const viewportMid = window.innerHeight / 2;

			sections.forEach((el) => {
				const rect = el.getBoundingClientRect();
				const elemMid = rect.top + rect.height / 2;
				const delta = viewportMid - elemMid;

				el.style.setProperty(
					'--parallax',
					`${delta * speed + baseOffset}px`
				);
			});
		};

		const onScroll = () => {
			if (!ticking) {
				requestAnimationFrame(() => {
					update();
					ticking = false;
				});
				ticking = true;
			}
		};

		window.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('resize', onScroll);

		// initial run
		update();
	};

	window.addEventListener('scroll', animateOnScroll, { passive: true });
	window.addEventListener('DOMContentLoaded', animateOnScroll);
	animateOnScroll();
}
